import React from 'react'

const ChevronIcon = ({ color }: { color: string }) => (
  <svg
    width='6'
    height='10'
    viewBox='0 0 6 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    role='presentation'
  >
    <path
      d='M4.9498 9.21094L1.0498 5.21094L4.9498 1.21094'
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default ChevronIcon
